// extracted by mini-css-extract-plugin
export default {"container":"styles_container__ZDp7U","avatar":"styles_avatar__ZytJQ","overflowAvatar":"styles_overflowAvatar__d3Fr5"};